import clsx from "classnames";
import classes from "./styles.module.scss";
import { useState } from "react";

export default function Collapsible({ title, awards, index, className }) {
  // const [isActive, setIsActive] = useState(false);
  const [isActive, setIsActive] = useState(title === "2025" || title === "2024");

  const handleCollapsibleClick = () => {
    setIsActive(!isActive);
  };

  const colors = ["#CB0666", "#B2C2BA", "#927D81"];

  const color = colors[index % colors.length];

  return (
    <div className={clsx(className, classes.collapsible)}>
      <div
        className={clsx(className, classes.collapsible_tab, isActive && classes.tab_active)}
        onClick={handleCollapsibleClick}
      >
        <h2 className={classes.year}>
          {title}
          <div className={classes.block} style={{ backgroundColor: color }}></div>
        </h2>
        <img
          alt="show more"
          className={clsx(className, classes.plus, isActive && classes.inactive)}
          src="/icons/plus.svg"
        ></img>
        <img
          alt="show less"
          className={clsx(className, classes.minus, isActive && classes.active)}
          src="/icons/minus.svg"
        ></img>
      </div>
      <div className={clsx(className, classes.collapsible_content, isActive ? classes.active : classes.inactive)}>
        {awards.map((award, index) => {
          return (
            <div className={classes.item} key={index}>
              <img alt={award.title} src={award.award_image}></img>
              <span className={classes.award_name}>{award.title}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

Collapsible.defaultProps = {
  className: "",
};
